import React from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'
import { Row, Col } from 'react-flexbox-grid'
import PopupTypes from '../../../popup_types'
import { FaIcon } from '../../../../shared/components';

const ActionButton = ({ disabled, handleOpenPopup, userIsCustomerManager, actionNameText }) => {
  return(
    <a onClick={ disabled ? null : handleOpenPopup } className={ `create_event_and_league_sim_golf_button ${disabled ? '' : 'clickable'} ${userIsCustomerManager ? '' : 'hidden'}` }>
      <Panel className='league-creation-button' >
        <Row className='button_container'>
          <Col className='icon_container'>
            <FaIcon icon={'square-plus-o'} size={'lg'}/>
          </Col>
          <Col className='name_container'>
            <h4>{ actionNameText }</h4>
          </Col>
        </Row>
      </Panel>
    </a>
  )
}

ActionButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleOpenPopup: PropTypes.func.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
  actionNameText: PropTypes.string.isRequired,
}

const CreateEventAndLeagueButtonSimGolf = ({ openPopup, disabled, userIsCustomerManager }) => {
  const handleOpenPopup = openPopup.bind(this, PopupTypes.CREATE_CLONE_EVENT_LEAGUE)
  const actionNameText = (!window.I18n ? '' : window.I18n.t('customer_center_comp.components.action_buttons.quick_event_button.quick_event_setup_sim_golf'))

  return (
    <span className='create_event_and_league_sim_golf'>
      <span className='title_container'>
        <h1 className='title  hidden-xs'>{ window.I18n.t('customer_center_comp.components.action_buttons.dashboard') }</h1>
        <p className='description'>{ window.I18n.t('customer_center_comp.components.action_buttons.dashboard_description') }</p>
      </span>
      <ActionButton
        disabled={ disabled }
        handleOpenPopup={ handleOpenPopup }
        userIsCustomerManager={ userIsCustomerManager }
        actionNameText={ actionNameText }
      />
    </span>
  )
}

CreateEventAndLeagueButtonSimGolf.propTypes = {
  disabled: PropTypes.bool.isRequired,
  openPopup: PropTypes.func.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
}

export default CreateEventAndLeagueButtonSimGolf